/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `vehicle` - Vehicle
 * * `trailer` - Trailer
 */
export enum VehicleType {
  VEHICLE = 'vehicle',
  TRAILER = 'trailer',
}
